export default __webpack_public_path__ + "static/media/Pro-2a.51f0054f.png";